import { useNavigate } from 'react-router-dom';
import { DEAL_STATUS_LABELS, DEAL_STATUS_COLORS } from '@/types/deal';
import type { Deal } from '@/types/deal';
import styles from './DealListView.module.css';

interface DealListViewProps {
  deals: Deal[];
}

export const DealListView = ({ deals }: DealListViewProps) => {
  const navigate = useNavigate();

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Company</th>
            <th>Information</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {deals.map((deal) => (
            <tr
              key={deal.id}
              className={styles.row}
              onClick={() => navigate(`/dashboard/deals/${deal.id}`)}
              style={{ '--row-accent': DEAL_STATUS_COLORS[deal.status] } as React.CSSProperties}
            >
              <td className={styles.clientCell}>{deal.client_name}</td>
              <td>
                <div className={styles.notesCell}>{deal.notes || '—'}</div>
              </td>
              <td>
                <span
                  className={styles.statusPill}
                  style={{ background: DEAL_STATUS_COLORS[deal.status] }}
                >
                  {DEAL_STATUS_LABELS[deal.status]}
                </span>
              </td>
              <td className={styles.dateCell}>
                {deal.event_date ? new Date(deal.event_date).toLocaleDateString('en-US') : '—'}
              </td>
            </tr>
          ))}
          {deals.length === 0 && (
            <tr>
              <td colSpan={4} className={styles.empty}>
                No deals yet
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
